import React, { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { observer } from "mobx-react";

import { Button } from "@components/buttons";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { BetCancelStore } from "@state/stores/my-bets/BetCancelStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";

export const BetDetailsBetCancel = observer(function BetDetailsBetCancel() {
	const store = useContext(BetDetailsModalStoreContext);

	const { t } = useTranslation();

	let betCancelStore: BetCancelStore;

	const [isYesButtonDisabled, setIsYesButtonDisabled] =
		useState<boolean>(false);

	if (store instanceof BetDetailsModalStore) {
		betCancelStore = store.myBetsStore.betCancelStore;
	} else {
		betCancelStore = store.betCancelStore;
	}

	return (
		<div className="popup__footer popup__footer--bordered">
			<div className="popup__header u-padd--reset">
				{t("ACC_STATEMENT.BET_DETAILS.COMBINATIONS.SLIP_TITLE")}
			</div>
			<div className="popup__footer__row">
				{t("mybets:CANCEL_SLIP_TEXT")}
			</div>
			<div className="popup__footer u-padd--reset">
				<button
					className="at-slipCancelSecondaryBtn popup__btn popup__btn--secondary btn btn--base btn--primary--inverted"
					type="button"
					onClick={() => {
						betCancelStore.onExitBetCancelBetDetailsModal();
						store.onBetCancelCloseStay();
					}}
				>
					{t("COMMON.CANCEL")}
				</button>
				<Button
					className="at-slipCancelPrimaryBtn popup__btn popup__btn--primary btn btn--base btn--accent"
					type="button"
					onClick={async () => {
						setIsYesButtonDisabled(true);
						await betCancelStore.onBetCancelConfirm();
						store.onBetCancelClose();
					}}
					disabled={isYesButtonDisabled}
					btnText={t("COMMON.YES")}
				></Button>
			</div>
		</div>
	);
});
